/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.timelineframe[_ngcontent-%COMP%]{top:0;left:0;width:100%;border-radius:5px;height:10px;position:relative;border:1px solid rgba(0,0,0,.5)}div.barwrapper[_ngcontent-%COMP%]{position:absolute;top:1px;height:8px}div.timelinemarker[_ngcontent-%COMP%]{position:absolute;width:15px;height:15px}div.padtop[_ngcontent-%COMP%]{margin-top:10px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/ui/timeline/timeline.component.css.shim.ngstyle.js.pre-build-optimizer.js